<template>
  <div
    class="as-nav-tabs-btn"
    :class="{
      [`as-nav-tabs-btn-${siteName}`]: siteName,
      'as-nav-tabs-btn__border': isShowBorder,
    }"
  >
    <div
      v-for="tab in tabs"
      :key="tab.key"
      class="as-nav-item"
      :class="{ active: activeTab === tab.key }"
      @click="changeTag(tab.key)"
    >
      <span class="as-extra-item"></span>
      {{ tab.title }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";

const commonStore = usecommonStore();
const emits = defineEmits(["change"]);


interface ITabsBtnItem {
  key: string;
  title: string;
}

interface IProps {
  tabs: ITabsBtnItem[];
  activeTab: string;
  isShowBorder?: boolean;
}

withDefaults(defineProps<IProps>(), {
  activeTab: "",
  isShowBorderTop: false,
});

const siteName = computed(() => commonStore.getSiteName);

const changeTag = (tag: string) => {
  emits("change", tag);
};
</script>

<script lang="ts">
export default {};
</script>
